// Date Utilities
function incrementDateInt(dateInt, increment) {
    return parseInt(
        moment(dateInt, _SugarWOD.constants.dateFormats.asInteger)
            .add(increment, "days")
            .format(_SugarWOD.constants.dateFormats.asInteger),
        10
    );
}

function momentAsDateInt(mom) {
    return parseInt(mom.format(_SugarWOD.constants.dateFormats.asInteger), 10);
}

function dateIntAsMoment(dateInt) {
    return moment(dateInt, _SugarWOD.constants.dateFormats.asInteger);
}

function formatDateInt(dateInt, format) {
    return dateIntAsMoment(dateInt).format(format);
}

module.exports = {
    incrementDateInt,
    momentAsDateInt,
    dateIntAsMoment,
    formatDateInt,
};
